/*
 * @Description:
 * @Author: liangziyao
 * @Date: 2021-08-23 19:56:24
 */
import { deviceType } from "./index";

const translatePosiPC = [
  { x: 410, y: 216 },
  { x: 565, y: 82 ,r:30},
  { x: 168, y: 92 ,r:78},
  { x: 84, y: 190 ,r:30},
  { x: 590, y: 194 ,r:-90},
  { x: 350, y: 100 },
  { x: 270, y: 216 },
  { x: 20, y: 124 ,r:70},
  { x: 29, y: 159 ,r:-70},
  { x: 250, y: 210 },
  { x: 496, y: 100 },
  { x: 200, y: 60 },
  { x: 280, y: 0,r:-70 },
  { x: 376, y: 211 },
  { x: 510, y: 200 },
  { x: 196, y: 190,r:-30 },
  { x: 61, y: 80,r:-70 },
  { x: -10, y: 190 },
  { x: 277, y: 130,r:-50 },
  { x: 435, y: 92 ,r:-20},

]

const translatePosiMobile = [
  { x: 390, y: 196 },
  { x: 465, y: 62 ,r:30},
  { x: 168, y: 92 ,r:78},
  { x: 84, y: 170 ,r:30},
  { x: 490, y: 174 ,r:-90},
  { x: 330, y: 90 },
  { x: 250, y: 196 },
  { x: 20, y: 104 ,r:70},
  { x: 29, y: 139 ,r:-70},
  { x: 250, y: 210 },
  { x: 446, y: 90 },
  { x: 200, y: 60 },
  { x: 280, y: 0 ,r:-70},
  { x: 346, y: 191 },
  { x: 510, y: 200 },
  { x: 176, y: 170 ,r:-30}, 
  { x: 61, y: 80 ,r:-70},
  { x: -10, y: 170 },
  { x: 257, y: 110 ,r:-50},
  { x: 415, y: 82 ,r:-20},
 
]

class Animation {
  $ = null;
  isPlaying = false;
  frame = 0;
  randomIndex = 0;
  stopMark = [];
  stopFrame = 0;
  isInit = false;
  container = null;
  containerWidth = 0;
  containerHeight = 0;
  eggsArr = [];
  translatePosi = [];
  viewport = 0;
  eggStatus = [{
    x: 0, // 蛋蛋圆心的位置
    y: 0, // 蛋蛋圆心的位置
    speedX: 0,
    speedY: 0,
    directionX: 0, // 左 -1 | 右 1
    directionY: 0, // 上 -1 | 下 1
    radius: 0,
  }];
  backupEggOriginPosition = [{
    x: 0,
    y: 0
  }]
  _animationPlayBind = null;
  _animationStopBind = null;
  _loadHandler = null;
  _pendingTimer = null;
  _destroyed = false;
  _pageScale = 1;
  constructor() {
    let device = deviceType()
    if (device === 'pc') {
      this.viewport =1920;
      this.translatePosi = translatePosiPC;
      this._pageScale = Math.ceil(window.innerWidth || 1920) / 1920;
    } else {
      this.viewport = 750;
      this.translatePosi = translatePosiMobile;
      this._pageScale = Math.ceil(window.innerWidth || 750) / 750;
    }
    this._animationPlayBind = this._animationPlay.bind(this);
    this._animationStopBind = this._animationStop.bind(this);
    for (let i = 0, length = this.eggStatus.length; i < length; i++) {
      this.stopMark.push(0);
    }
    // 获取容器
    this.container = document.querySelector('.j-egg-container');
    // 获取蛋蛋
    for (let i = 0, length = 20; i < length; i++) {
      const ELEMENT = document.querySelector(`.j-egg-${i + 1}`);
      this.eggsArr.push(ELEMENT);
    }
  
      this._initOnload();
   
  }
  _initOnload() {
    this._initContainer();
    this._initEggs();
    this.isInit = true;
  }
  _initContainer() {
    let device = deviceType();
    if (device == 'pc') {
      this.containerWidth = 720;
      this.containerHeight = 310;
    } else {
      this.containerWidth = 606;
      this.containerHeight = 272;
    }
  }
  _initEggs() {
    this.eggStatus = [];
    this.backupEggOriginPosition = [];
    for (let i = 0, length = this.eggsArr.length; i < length; i++) {
      const EGG = this.eggsArr[i];
      let { width, height } = EGG.getBoundingClientRect();
      let { offsetLeft, offsetTop } = EGG;
      let speedX = Math.ceil(Math.random() * 5) + 5;
      let speedY = Math.ceil(Math.random() * 5) + 5;
      let directionX = Math.random() > 0.5 ? 1 : -1;
      let directionY = Math.random() > 0.5 ? 1 : -1;
      let radius = Math.ceil((width > height ? width : height) / 2);
      let egg = {
        width:width/this._pageScale,
        height:height/this._pageScale,
        directionX,
        directionY,
        speedX,
        speedY,
        radius,
        rotate: 0,
        x: this.translatePosi[i].x,
        y: this.translatePosi[i].y
        // x: (offsetLeft + radius) | 0,
        // y: (offsetTop + radius) | 0,
      }
      // 初始样式
      EGG.style.transitionDuration = 1000 / 60 + 'ms';
      // EGG.style.top = offsetTop + 'px';
      // EGG.style.left = offsetLeft + 'px';
      // EGG.style.transform = `translate3D(${offsetLeft}px, ${offsetTop}px, 0)`;
      this.eggStatus.push(egg);
      this.backupEggOriginPosition.push({
        x: offsetLeft,
        y: offsetTop
      })
    }
  }
  reset() {
    // 数据初始化
    for (let i = 0, length = this.eggStatus.length; i < length; i++) {
      this.stopMark[i] = 0;
    }
    // 让机器的蛋归位
    // for (let i = 0, length = this.backupEggOriginPosition.length; i < length; i++) {
    //   const EGG = this.eggsArr[i];
    //   let { x, y } = this.backupEggOriginPosition[i];
    // EGG.style.top = y + 'px';
    // EGG.style.left = x + 'px';
    // EGG.style.transform = `translate3D(${x}px, ${y}px, 0)`;
    // }
    this._resetEggPosi();
    // 让弹出来的蛋消失
    document
      .querySelector('.j-egg-show')
      .classList
      .remove(`egg-show-${this.randomIndex}`);
  }
  _resetEggPosi() {
    for (let i = 0, length = this.eggsArr.length; i < length; i++) {
    
      const EGG = this.eggsArr[i];
      const EGG_STATUS = this.eggStatus[i] || {x:0,y:0};
    
      let { x, y } = this.translatePosi[i];
   
      EGG_STATUS.x = x;
      EGG_STATUS.y = y;
      x = x / this.viewport * 100 + 'vw';
      y = y / this.viewport * 100 + 'vw';
      let r = this.translatePosi[i].r ? `rotate(${this.translatePosi[i].r}deg)` : "";
      EGG.style.transform = `translate3D(${x}, ${y}, 0) ${r}`;
    }
  }
  async start() {
   
    // 检查是否已销毁
    if (this._destroyed) {
      console.warn('Animation instance has been destroyed');
      return;
    }

    // 检查是否正在播放
    if (this.isPlaying) {
      return;
    }
  
    // 检查是否已初始化
    if (!this.isInit) {
      console.warn('Animation not initialized yet, waiting for load event');
      return;
    }

    this.reset();
    this.isPlaying = true;
  
    // 第一轮动画：扭蛋播放
    this.frame = window.requestAnimationFrame(this._animationPlayBind);

    await new Promise((resolve) => {
  
      const timeoutId = setTimeout(() => {
        // 扭蛋动画结束了
        if (this.frame) {
          window.cancelAnimationFrame(this.frame);
          this.frame = 0;
        }
        resolve();
      }, 2000)
      // 保存 timeout ID 以便可能的清理
      this._pendingTimer = timeoutId;
    })
    
    // 清理 timer 引用
    this._pendingTimer = null;
    
    // 弹出一个蛋
    this._animationResult();
    // 第二轮动画：滚动的蛋要掉回下来
    this.stopFrame = window.requestAnimationFrame(this._animationStopBind);
    // 判断动画全部结束
    await new Promise((resolve, reject) => {
      let timer = null;
      let checkCount = 0;
      const maxChecks = 5; // 最多检查5秒，避免死循环
      
      timer = setInterval(() => {
        checkCount++;
        if (!this.isPlaying) {
          clearInterval(timer);
          this._pendingTimer = null;
          resolve();
        } else if (checkCount >= maxChecks) {
          // 超时保护：强制停止
          clearInterval(timer);
          this._pendingTimer = null;
          this.isPlaying = false;
          if (this.stopFrame) {
            window.cancelAnimationFrame(this.stopFrame);
            this.stopFrame = 0;
          }
          console.warn('Animation timeout after 5 seconds, force stopped');
          resolve();
        }
      }, 1000)
      
      this._pendingTimer = timer;
    })

    return Promise.resolve();
  }
  _animationPlay() {
    // 检查是否已销毁
    if (this._destroyed) {
      if (this.frame) {
        window.cancelAnimationFrame(this.frame);
        this.frame = 0;
      }
      return;
    }
    
    for (let i = 0, length = this.eggStatus.length; i < length; i++) {
      const EGG = this.eggStatus[i];
      // 边缘碰撞检测，改变运动方向
      let minX = 0,
        minY = 0,
        maxX = this.containerWidth - EGG.width * 1.8,
        maxY = this.containerHeight - EGG.height;
      // 碰上
      EGG.y <= minY && (EGG.directionY = 1);
      // 碰下
      EGG.y >= maxY && (EGG.directionY = -1);
      // 碰左
      EGG.x <= minX && (EGG.directionX = 1);
      // 碰右
      EGG.x >= maxX && (EGG.directionX = -1);
      // 蛋蛋运动
      EGG.rotate += 6;
      EGG.rotate >= 360 && (EGG.rotate = 0);
      EGG.y = (EGG.y + EGG.speedY * EGG.directionY);
      EGG.x = (EGG.x + EGG.speedX * EGG.directionX);
      let x = EGG.x / this.viewport * 100;
      let y = EGG.y / this.viewport * 100;

      // this.eggsArr[i].style.top = EGG.y + 'px';
      // this.eggsArr[i].style.left = EGG.x + 'px';
      this.eggsArr[i].style.transform = `translate3D(${x}vw, ${y}vw, 0) rotate(${EGG.rotate}deg)`;
      // if(i==1){
      //   console.log(x,y,maxX,maxY,EGG.width,EGG.height, this.containerWidth,this.containerHeight)
      // }
    }

    this.frame = window.requestAnimationFrame(this._animationPlayBind);
  }
  _animationStop() {
    // 检查是否已销毁
    if (this._destroyed) {
      if (this.stopFrame) {
        window.cancelAnimationFrame(this.stopFrame);
        this.stopFrame = 0;
      }
      this.isPlaying = false;
      return;
    }
    
    if (!this.stopMark.includes(0)) {
      this.isPlaying = false;
      window.cancelAnimationFrame(this.stopFrame);
      this.stopFrame = 0;
      return;
    }
    for (let i = 0, length = this.eggStatus.length; i < length; i++) {
      const EGG = this.eggStatus[i];
      EGG.y = EGG.y + EGG.speedY;
      if (EGG.y >= this.containerHeight - EGG.height) {
        this.stopMark[i] = 1;
        continue;
      }
      this.eggStatus[i].rotate += 6;
      // this.eggsArr[i].style.top = EGG.y + 'px';
      let x = EGG.x / this.viewport * 100;
      let y = EGG.y / this.viewport * 100;
      this.eggsArr[i].style.transform = `translate3D(${x}vw, ${y}vw, 0) rotate(${this.eggStatus[i].rotate}deg)`;
    }
    this.stopFrame = window.requestAnimationFrame(this._animationStopBind);
  }
  _animationResult() {
    this.randomIndex = Math.ceil(Math.random() * 20);
    document
      .querySelector('.j-egg-show')
      .classList
      .add(`egg-show-${this.randomIndex}`);
  }
  // 销毁实例，清理所有资源
  destroy() {
    if (this._destroyed) {
      return;
    }
    
    this._destroyed = true;
    
    // 取消所有动画帧
    if (this.frame) {
      window.cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
    if (this.stopFrame) {
      window.cancelAnimationFrame(this.stopFrame);
      this.stopFrame = 0;
    }
    
    // 清理定时器
    if (this._pendingTimer) {
      if (typeof this._pendingTimer === 'number') {
        clearTimeout(this._pendingTimer);
      } else {
        clearInterval(this._pendingTimer);
      }
      this._pendingTimer = null;
    }
    
    // 移除事件监听器
    if (this._loadHandler) {
      window.removeEventListener('load', this._loadHandler);
      this._loadHandler = null;
    }
    
    // 重置状态
    this.isPlaying = false;
    
    // 清理 DOM 引用（避免内存泄漏）
    this.container = null;
    this.eggsArr = [];
    this.eggStatus = [];
    this.backupEggOriginPosition = [];
    
    console.log('Animation instance destroyed');
  }
  get(key) {
    return this[key];
  }
  set(key, value) {
    this[key] = value;
  }
}


export default Animation;
